export default function () {
  var pommi = $('.tifigs-pommfritt');
  var navi = $('.navigation__level.default > .navigation__list');
  var links = navi.find('>li');
  var active = navi.find('>li.active');
  var aColor = "black";
  //console.log("hoi");

  links.on('mouseenter', function (e) {
      var target = $(e.currentTarget);
      navi.addClass("hovering");
      //links.css('color', 'black');
      //target.css('color', "black");
      freese(e.target.clientWidth, target.offset().left - navi.offset().left);
  });

  if (active.length) {
      var activeItems = navi.find('>li.active');
      //activeItems.css('color', aColor)
      var activeLeft = activeItems.offset().left - navi.offset().left;
      var activeWidth = active[0].clientWidth;
      freese(activeWidth, activeLeft);

      // Zruggfreese
      links.on('mouseleave', function (e) {
        //links.css('color', 'black');
        //active.css('color', aColor);
        freese(activeWidth, activeLeft);
        navi.removeClass("hovering");
      });
  } else {
      links.on('mouseleave', function (e) {
        var target = $(e.currentTarget);
        //links.css('color', 'black');
        freese(0, target.offset().left - navi.offset().left);
        navi.removeClass("hovering");
      });
  }
  
  function freese (width, left) {
      pommi.css({
          width: width,
          transform: 'translate3d(' + left + 'px, 0, 0)'
      });
  }
};



// WEBPACK FOOTER //
// ./BBZP/Frontend/js/modules/tifigs-pommfritt.js